import { ArticleListPage, ResourceArticle } from "@/components/resources/ArticleListPage";

const guides: ResourceArticle[] = [
  {
    id: "premiere-boutique",
    title: "Créer votre première boutique en 15 minutes",
    category: "Démarrage",
    readTime: "5 min",
    excerpt: "Inscription, essai gratuit de 14 jours et configuration de base de votre boutique manuelle.",
    body: [
      "Commencez par créer votre compte gratuitement depuis la page d'inscription. Aucune carte bancaire n'est demandée pour démarrer l'essai de 14 jours.",
      "Depuis votre espace compte, choisissez « Création manuelle ». Donnez un nom à votre boutique, ajoutez une courte description et choisissez vos couleurs.",
      "Votre boutique est aussitôt accessible sur un sous-domaine sokoby.com. Vous pourrez connecter votre propre nom de domaine plus tard.",
    ],
  },
  {
    id: "ajouter-produits",
    title: "Ajouter et organiser vos produits",
    category: "Catalogue",
    readTime: "6 min",
    excerpt: "Photos, prix, stock et catégories : les bonnes pratiques pour une fiche produit qui vend.",
    body: [
      "Chaque produit doit avoir un titre clair, au moins trois photos de qualité et une description qui répond aux questions de vos clients.",
      "Renseignez le stock pour éviter de vendre un article indisponible, et classez vos produits par catégorie pour faciliter la navigation.",
      "Vous pouvez aussi importer vos produits en masse depuis un fichier ou depuis une autre plateforme.",
    ],
  },
  {
    id: "choisir-theme",
    title: "Choisir et personnaliser votre thème",
    category: "Design",
    readTime: "4 min",
    excerpt: "Logo, couleurs, polices et sections de page d'accueil pour une boutique à votre image.",
    body: [
      "Dans l'éditeur de boutique, parcourez les thèmes disponibles et prévisualisez-les avant de les appliquer.",
      "Ajoutez votre logo et vos couleurs de marque : ils sont appliqués automatiquement sur toute la boutique.",
      "Réorganisez les sections de la page d'accueil (bannière, produits vedettes, avis clients) pour mettre en avant vos meilleures ventes.",
    ],
  },
  {
    id: "paiements",
    title: "Configurer les paiements",
    category: "Paiements",
    readTime: "5 min",
    excerpt: "Connectez Stripe ou PayPal pour encaisser vos ventes en toute sécurité.",
    body: [
      "Dans les paramètres de paiement, connectez votre compte Stripe ou PayPal. Vos identifiants restent privés et propres à votre boutique.",
      "Faites une commande test avant de lancer votre boutique pour vérifier que tout fonctionne.",
    ],
  },
  {
    id: "domaine",
    title: "Connecter votre nom de domaine",
    category: "Domaines",
    readTime: "4 min",
    excerpt: "Achetez un domaine ou reliez celui que vous possédez déjà.",
    body: [
      "Depuis la section Domaines, recherchez un nom disponible et achetez-le directement, ou connectez un domaine existant.",
      "Pour un domaine existant, ajoutez les enregistrements DNS indiqués chez votre registraire. La vérification prend généralement quelques minutes à quelques heures.",
    ],
  },
  {
    id: "seo",
    title: "Améliorer votre référencement (SEO)",
    category: "Marketing",
    readTime: "7 min",
    excerpt: "Titres, descriptions et adresses de pages optimisés pour être trouvé sur Google.",
    body: [
      "Rédigez un titre et une description SEO uniques pour chaque produit, en utilisant les mots que vos clients recherchent.",
      "Sokoby génère automatiquement le plan de site et les données structurées de vos produits pour aider les moteurs de recherche.",
    ],
  },
];

export default function GuidesTutoriels() {
  return (
    <ArticleListPage
      title="Guides et tutoriels"
      intro="Des guides pas à pas pour lancer, gérer et développer votre boutique Sokoby."
      articles={guides}
      cta={{ label: "Besoin d'aide personnalisée ? Contactez le support", to: "/support" }}
    />
  );
}
